import { lazy } from "react";

import CertificateIcon from "../../../../../src/assets/images/certificatee-icon.svg";

import LottieAnimationFile from "../../../../assets/lotties/certificate-confetti.json";

import Modal from "../../../modal/Modal";

import Button from "../ButtonComponent";
import { BUTTON_VARIANTS } from "../constant";

import styles from "./styles.module.scss";

import { LMS_MODULE_NAME } from "../../../../utils/cookiesmanager";

const LottiePlayerClient = lazy(() => import("../Lottie/index"));

const ModuleCertificateStatusModal = (props) => {
  const { show , handleRedirection } = props;

  const userData  = localStorage.getItem('user');
  const {firstName} = userData || {};
  const moduleName = localStorage.getItem(LMS_MODULE_NAME)

  return (
    <>
      <Modal visible={show}>
        <div className={styles["certificate-wrapper"]}>
          <div className={styles["confetti-wrapper"]}>
            <LottiePlayerClient
              animationData={LottieAnimationFile}
              loop={false}
              autoplay
            />
          </div>

          <div className={styles["content-wrapper"]}>
            <div className={styles["certificate-icon"]}>
              <img src={CertificateIcon} alt="" />
            </div>

            <div className={styles.title}>Dear {firstName}</div>

            <div className={styles.description}>
              Your certificate is ready for the {[moduleName]}
              <p className={styles["para-text"]}>
                You can download it from the Certificate menu.
              </p>
            </div>

            <div className={styles["button-wrapper"]}>
              <Button
                label="Back to Module"
                buttonVariant={BUTTON_VARIANTS.PRIMARY}
                onClick={handleRedirection}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModuleCertificateStatusModal;
